<template>
    <div class="content">
        <div class="page_searcher">
            <Searcher :items="config.searchers" @search="getData" :download="true" ref="searcher"/>
        </div>
    </div>
</template>  

<script>
import {ctrlMixin} from '@/utils/ctrlMixin.js'
import Searcher from '@/components/common/search/searcher.vue'
export default {
    mixins: [ctrlMixin],
    components: {
        Searcher,
    },
    methods: {
        // 获取页面数据
        getData(params) {
            this.loading = true
            this.$service.queryDownload(this.queryId, params, this)
        },
    },
    data() {
        return {
        }
    },
}
</script>